import ChooseProjectHeaderMixinProps from '../common/ChooseProjectHeaderMixin.props';

// name of fields in CreationWizard root component state
export default {
	// selectedProjectId: { type: Number }, // included in ChooseProjectHeaderMixinProps
	...ChooseProjectHeaderMixinProps,
	selectedToolPlacementId: { type: String },
};
